import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { composables, currentQuery, getPaginator } from '@orange-marmalade/paginate-this';
import URI from 'urijs';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { each, isArray, isObject } from 'underscore';
import { push as routerPush, replace as routerReplace } from 'react-router-redux';

class UrlToPaginateState extends PureComponent {
  static propTypes = {
    syncSearchToState: PropTypes.func,
    params: PropTypes.object,
    location: PropTypes.object,
    query: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      query: props && props.query ? JSON.parse(props.query) : undefined
    };
  }

  componentWillReceiveProps(nextProps) {
    const oldQuery = this.props.query;
    const oldDefaultQuery = this.props.defaultQuery;
    const { query, defaultQuery } = nextProps;

    if (oldQuery !== query || defaultQuery !== oldDefaultQuery) {
      this.setState({
        query: {
          ...defaultQuery,
          ...(query ? JSON.parse(query) : undefined)
        }
      });
    }
  }

  render() {
    const { query } = this.state;

    return React.cloneElement(this.props.children, {
      ...this.props,
      query
    });
  }

  componentDidMount() {
    const {
      defaultQuery,
      syncSearchToState,
      match: { params },
      location
    } = this.props;
    const { query } = this.state;
    syncSearchToState({
      search: {
        ...defaultQuery,
        ...URI(location.search).search(true)
      },
      initial: true,
      filters: {
        ...params,
        ...query
      }
    });

    this.checkAndLoad();
  }

  componentWillUpdate(nextProps) {
    const {
      defaultQuery,
      syncSearchToState,
      match: { params },
      location
    } = nextProps;
    const { query } = this.state;
    syncSearchToState({
      search: {
        ...defaultQuery,
        ...URI(location.search).search(true)
      },
      filters: {
        ...params,
        ...query
      }
    });
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { autoload, stale, isLoading, hasLoadError, reload } = this.props;
    if (autoload && stale && !isLoading && !hasLoadError) {
      reload();
    }
  }
}

class PaginateThisDuckCreator {
  constructor({ listId, defaultQuery, availableFilters = [], locator, abortRequest }) {
    this.listId = listId;
    this.defaultQuery = defaultQuery;
    this.availableFilters = availableFilters;
    this.locator = locator;
    this.abortRequest = abortRequest;

    this.pageActions = composables({
      listId: listId,
      preloaded: {}
    });
  }

  syncSearchToState(getAdditonalFilters, { search = {}, filters = {}, initial = false }) {
    return (dispatch, getState) => {
      var doExpire = false,
        pageActions = this.pageActions;

      var query = {
        ...filters,
        ...this.defaultQuery,
        ...search
      };

      const state = getState();
      var list = this.getListInState(state);

      var { sort, sortReverse, currentSort, currentSortReverse } = this.getQuerySort(
        list,
        query
      );
      if (sort !== currentSort || sortReverse !== currentSortReverse) {
        doExpire = true;
        dispatch(pageActions.sort(sort, sortReverse));
      }

      var filtersToSet = {};
      var setFilters = false;

      each(this.availableFilters, function (filter, key) {
        var transformer = typeof key === 'string' ? filter : undefined;
        filter = typeof key === 'string' ? key : filter;

        var value = query[filter];
        var oldValue = list.getIn(['filters', filter]);

        if (transformer) {
          value = transformer(value);
        } else if (typeof oldValue === 'number') {
          value = isNaN(parseFloat(value, 10)) ? value : parseFloat(value, 10);
        }

        if (value !== undefined) {
          filtersToSet[filter] = value === null ? undefined : value;
        }

        if (oldValue !== value) {
          setFilters = true;
        }
      });

      if (getAdditonalFilters) {
        let additionalFilters = getAdditonalFilters(state) || {};

        each(Object.keys(additionalFilters), function (key) {
          var value = additionalFilters[key];
          var oldValue = list.getIn(['filters', key]);

          if (value !== undefined) {
            filtersToSet[key] = value === null ? undefined : value;
          }

          if (oldValue !== value) {
            setFilters = true;
          }
        });
      }

      if (setFilters) {
        doExpire = true;
        dispatch(pageActions.setFilters(filtersToSet));
      }

      var { page, pageSize, currentPage, currentPageSize } = this.getQueryPage(
        list,
        query
      );

      if (currentPageSize !== pageSize) {
        doExpire = true;
        dispatch(pageActions.setPageSize(pageSize));
      }

      if (page !== currentPage) {
        doExpire = true;
        dispatch(pageActions.goTo(page));
      }

      if (initial && !doExpire) {
        dispatch(pageActions.expire());
      }

      if (doExpire && !initial && this.abortRequest) {
        dispatch(this.abortRequest());
      }
    };
  }

  submitSearch({ to, values, replace, force, search = {} }) {
    return (dispatch, getState) => {
      const state = getState();
      const paginator = getPaginator(this.listId, state);
      const filters = paginator.get('filters');
      const defaultQuery = this.defaultQuery;
      // const pageActions = this.pageActions;
      var doSubmit = false;

      Object.keys(this.availableFilters).forEach(function (key) {
        // filters.mapKeys(function(key) {
        const filterValue = filters.get(key);
        var value = values[key];

        if (isArray(value)) {
          value = value.join(',');
        } else if (isObject(value)) {
          value = JSON.stringify(value);
        }

        if (filterValue !== value) {
          doSubmit = true;
        }

        if (
          (defaultQuery.hasOwnProperty(key) && defaultQuery[key] !== value) ||
          (value !== '' && value !== null)
        ) {
          search[key] = value;
        }
      });

      if (doSubmit || force) {
        // dispatch(pageActions.setFilters(search));
        // clearTimeout(this.submitTimeout);
        // this.submitTimeout = setTimeout(() => {
        const action = replace ? routerReplace : routerPush;
        // console.log('Handle Submit', search, defaultQuery);
        dispatch(
          action(
            URI(to)
              .search({
                ...defaultQuery,
                pageSize: paginator.get('pageSize'),
                ...search
              })
              .toString()
          )
        );
        // }, 100);
      } else {
        console.log('Ignoring Submit');
      }
    };
  }

  getListInState(state) {
    return getPaginator(this.listId, state);
  }

  getQueryPage(list, { page, pageSize }) {
    page = page !== undefined && page !== '' ? parseInt(page, 10) : 1;
    pageSize = pageSize !== undefined && pageSize !== '' ? parseInt(pageSize, 10) : 15;

    return {
      page,
      pageSize,
      currentPage: list.get('page'),
      currentPageSize: list.get('pageSize')
    };
  }

  getQuerySort(list, { sortOrder, sort }) {
    var sortReverse = (sortOrder || '').trim().toLowerCase() === 'desc',
      currentSort = list.get('sort'),
      currentSortReverse = list.get('sortReverse');

    sort = sort !== undefined ? sort : currentSort;

    return {
      sort,
      sortOrder,
      sortReverse,
      currentSort,
      currentSortReverse
    };
  }

  clearResults() {
    return this.pageActions.reset({
      totalCount: 0,
      initialized: true,
      stale: false
    });
  }

  resetResults() {
    return this.pageActions.resetResults([]);
  }

  expire() {
    return this.pageActions.expire();
  }

  resetFilters(filters) {
    return this.pageActions.resetFilters(filters);
  }

  setFilters(filters) {
    return this.pageActions.setFilters(filters);
  }

  decorate(Component, defaultQuery = {}, getAdditonalFilters) {
    const syncSearchToState = this.syncSearchToState.bind(this, getAdditonalFilters);
    const submitSearch = this.submitSearch.bind(this);
    const clearResults = this.clearResults.bind(this);
    const resetResults = this.resetResults.bind(this);
    const resetFilters = this.resetFilters.bind(this);
    const setFilters = this.setFilters.bind(this);
    const expire = this.expire.bind(this);
    const listId = this.listId;

    // Add location props
    return withRouter(
      // Parse out current 'query'
      connect(
        (state, props) => {
          const query = JSON.stringify(currentQuery(state, listId).query);
          const list = this.getListInState(state);

          var defaultPageQuery = defaultQuery;
          if (typeof defaultPageQuery === 'function') {
            defaultPageQuery = defaultPageQuery(state, props);
          }

          return {
            defaultQuery: defaultPageQuery,
            getAdditonalFilters,
            listId,
            query,
            stale: list.get('stale'),
            isLoading: list.get('isLoading'),
            hasLoadError: !!list.get('loadError')
          };
        },
        {
          syncSearchToState,
          submitSearch,
          clearResults,
          resetResults,
          resetFilters,
          setFilters,
          expire,
          reload: this.pageActions.reload
        }
      )(props => {
        return (
          <UrlToPaginateState {...props}>
            <Component />
          </UrlToPaginateState>
        );
      })
    );
  }
}

export default PaginateThisDuckCreator;



// WEBPACK FOOTER //
// ./src/middleware/paginate-this.js